import Immutable from 'immutable';

import * as Models from 'models';
import { applyBoxProperty } from './applyBoxProperty';

export const updatePadding = (
  layout: Models.LayoutMap,
  columnsWidth: Immutable.List<number>,
  padding: Models.PaddingMap,
  getMinColumnWidth: (position: number) => number,
): {
  layout: Models.LayoutMap;
  columnsWidth: Immutable.List<number>;
} => {
  const newColumnsWidth = applyBoxProperty(
    columnsWidth,
    layout.getIn(['styles', 'padding']),
    padding,
  );

  if (newColumnsWidth.every((column, idx) => column >= getMinColumnWidth(idx))) {
    return {
      layout: layout.setIn(['styles', 'padding'], padding),
      columnsWidth: newColumnsWidth,
    };
  }

  return {
    layout,
    columnsWidth,
  };
};
